/* istanbul ignore file */
// Not testable with Jest/jsdom

/**
 * Get scrollbar width
 *
 * This doesn’t work on macOS with the setting
 * ‘General > Show scroll bars > When scrolling’
 *
 * It’s also not really testable in a virtual DOM
 * environment in Jest (uses jsdom)
 *
 * Source:
 * https://stackoverflow.com/a/13382873
 */
export default function () {
  if (window.innerHeight > document.body.offsetHeight) {
    return 0
  }

  let outer = document.createElement('div')
  let inner = document.createElement('div')

  outer.style.visibility = 'hidden'
  outer.style.width = '100px'
  outer.style.msOverflowStyle = 'scrollbar'

  // Add outer to document
  document.body.appendChild(outer)

  const outerWidth = outer.offsetWidth

  // Force scrollbar
  outer.style.overflow = 'scroll'
  inner.style.width = '100%'

  // Add inner to outer
  outer.appendChild(inner)

  const innerWidth = inner.offsetWidth

  // Remove outer from document
  outer.parentNode.removeChild(outer)

  return outerWidth - innerWidth
}
